<div class="content-wrapper reports-container">
  <!-- Content Header (Page header) -->
  <div
    class="col-md-12 layout-spacing widget quick-category"
    style="margin-top: 30px"
  >
    <a class="widget quick-category">
      <div class="quick-category-head">
        <h5 class="card-title">{{ 'record.filter.title' | translate }}</h5>
        <div class="ml-auto">
          <button
            *ngIf="!areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.contract' | translate }}</span>
            <i class="las la-arrow-up"></i>
          </button>
          <button
            *ngIf="areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.advancedSearch' | translate }}</span>
            <i class="las la-arrow-down"></i>
          </button>
        </div>
      </div>
      <div class="quick-category-content">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.startDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="minDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [maxDate]="maxDate"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.endDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="maxDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [minDate]="minDate"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row" [ngbCollapse]="areFiltersCollapsed">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">{{ 'record.filter.user' | translate }}</h6>
              <div>
                <input
                  [(ngModel)]="user"
                  class="form-control"
                  placeholder="{{ 'record.filter.emailAddress' | translate }}"
                  type="text"
                  id="example-text-input"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.table.type' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="actions"
                [closeOnSelect]="false"
                [(ngModel)]="selectedActions"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.table.act' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="activityTypeOptions"
                [closeOnSelect]="false"
                [(ngModel)]="selectedActivityTypes"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.department' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                (scrollToEnd)="cargarMasOpciones()"
                [items]="departments"
                [closeOnSelect]="false"
                [(ngModel)]="selectedDeptos"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'utilities.filters.sensitivyData' | translate }}
              </h6>
              <div class="checkbox-wrapper-13 ml-3">
                <input id="c1-13" type="checkbox" [(ngModel)]="checkboxSi" />
                <label for="c1-13">{{
                  'utilities.filters.yes' | translate
                }}</label>

                <input
                  id="c1-14"
                  class="ml-3"
                  type="checkbox"
                  [(ngModel)]="checkboxNo"
                />
                <label for="c1-14">{{
                  'utilities.filters.no' | translate
                }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="btn-filtros">
              <button
                style="padding: 5px 30px; width: 110px"
                type="button"
                class="btn btn-primary"
                [disabled]="isLoading"
                (click)="setFilters()"
              >
                {{ 'record.filter.filter' | translate }}
              </button>
              <button
                style="padding: 5px 0px; width: 110px"
                type="button"
                class="btn btn-outline-primary"
                [disabled]="isLoading"
                (click)="cleanFilters()"
              >
                {{ 'record.filter.cleanFilters' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </a>

    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <div class="btn-informes">
          <button
            style="
              padding: 5px 25px;
              width: 165px;
              height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 6px;
            "
            id="btnGroupVerticalDropdown"
            type="button"
            class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            [disabled]="isLoading"
          >
            <i class="icon download-button" style="height: 17px"></i>
            {{ 'record.download.download' | translate }}
            <i class="las la-angle-down"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDropdown">
            <button class="dropdown-item" (click)="generateGeneralIrmReport()">
              <i class="icon download-type"></i>
              {{ 'record.download.overviewReport' | translate }}
            </button>
            <button class="dropdown-item" (click)="generateEvoDlpReport()">
              <i class="icon download-type"></i>
              {{ 'record.download.evolutionaryReport' | translate }}
            </button>
          </div>
        </div>
        <div class="d-flex align-items-center gap-1">
          <ng-container *ngIf="!isCountLoading">
            {{ 'record.recordsCount' | translate : { count: reports?.length || '0', total: collectionSize } }}
          </ng-container>
          <ng-container *ngIf="isCountLoading">
            {{ 'record.recordsCountLoading' | translate : { count: reports?.length || '0' } }}
            <span class="spinner-border spinner-border-sm text-secondary" style="width:0.75rem;height:0.75rem;margin-left:4px" role="status" aria-hidden="true"></span>
          </ng-container>
        </div>
      </div>
    </div>

    <div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th
              scope="col"
              sortable="date"
              (sort)="onSort($event)"
              style="width: 12%"
            >
              {{ 'record.table.date' | translate }}
            </th>
            <th scope="col" sortable="act" (sort)="onSort($event)">
              {{ 'record.table.act' | translate }}
            </th>
            <th scope="col">
              {{ 'record.table.file' | translate }}
            </th>
            <th scope="col" sortable="user" (sort)="onSort($event)">
              {{ 'record.table.user' | translate }}
            </th>
            <th scope="col" sortable="department" (sort)="onSort($event)">
              {{ 'record.table.department' | translate }}
            </th>
            <th scope="col" sortable="origin" (sort)="onSort($event)">
              {{ 'record.table.origin' | translate }}
            </th>
            <th scope="col" sortable="sensitiveData">
              {{ 'record.table.sensitiveData' | translate }}
            </th>
          </tr>
        </thead>
        <tbody *ngIf="isLoading">
          <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
          </tr>
        </tbody>
        <tbody *ngIf="!isLoading">
          <tr
            style="height: 50px; overflow: scroll"
            *ngFor="let report of reports"
          >
            <td>{{ report.date | tableDate }}</td>
            <td
              data-toggle="tooltip"
              placement="top"
              animation="true"
              container="body"
              [openDelay]="300"
              [closeDelay]="300"
              ngbTooltip="{{ report.action }}"
            >
              {{ (report.action | cutString) || '' }}
            </td>
            <td
              data-toggle="tooltip"
              placement="top"
              animation="true"
              container="body"
              [openDelay]="300"
              [closeDelay]="300"
              [ngbTooltip]="report.resourceNames?.join(', ')"
            >
              {{ (report.resourceNames?.join(', ') | cutString) || '' }}
            </td>
            <td>
              {{
                report.actor
                  ? report.actor
                  : 'DlpClassificationItemAssistantTeams'
              }}
            </td>
            <td>{{ report.area }}</td>
            <td>{{ report.origin }}</td>
            <td>
              <span
                style="color: #4456b9; cursor: pointer"
                (click)="seeSensitiveData(report.sensitiveInformationTypes)"
                *ngIf="
                  report.sensitiveInformationTypes.length !== 0 &&
                  report.sensitiveInformationTypes.count !== 0
                "
              >
                {{ 'record.table.seeSensitiveData' | translate }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      *ngIf="reports?.length <= 0 && !isLoading"
      class="d-flex justify-content-center"
    >
      <span>{{ 'noDataAvailable' | translate }}</span>
    </div>
  </div>

  <div
    class="d-flex justify-content-center p-2 paginator-container"
    *ngIf="reports?.length > 0"
  >
    <div class="items-per-page-container">
      <label for="pageSizeSelect" class="mr-2 mb-0">{{
        'record.filter.itemsPerPage' | translate
      }}</label>
      <select
        id="pageSizeSelect"
        class="form-control"
        style="width: auto; display: inline-block"
        [(ngModel)]="pageSize"
        (change)="refreshReports()"
      >
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <ngb-pagination
      [collectionSize]="collectionSize"
      [(page)]="page"
      [pageSize]="pageSize"
      [rotate]="true"
      [maxSize]="5"
      [ellipses]="false"
      [boundaryLinks]="true"
      (pageChange)="refreshReports()"
    >
    </ngb-pagination>
  </div>
</div>
